import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initConfig } from "./config";
import "./i18n";
import "./index.css";

/**
 * Initialize the application
 * Loads runtime config before rendering
 */
async function init() {
  // Load runtime configuration from /config.json
  await initConfig();

  // Render the application
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

// Start the application
init().catch((error) => {
  console.error("[App] Failed to initialize:", error);
  // Show a basic error message if initialization fails
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML = `
      <div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-family: sans-serif;">
        <div style="text-align: center;">
          <h1>Application Error</h1>
          <p>Failed to initialize the application. Please refresh the page.</p>
        </div>
      </div>
    `;
  }
});
